var map = {
	"./default/black_king_default_back.svg": 163,
	"./default/black_pawn_default_back.svg": 1425,
	"./default/white_king_default_back.svg": 1033,
	"./default/white_pawn_default_back.svg": 4859,
	"./law/black_bishop_law_back.svg": 2306,
	"./law/black_king_law_back.svg": 2564,
	"./law/black_pawn_law_back.svg": 44,
	"./law/black_queen_law_back.svg": 2963,
	"./law/black_rook_law_back.svg": 6131,
	"./law/white_bishop_law_back.svg": 8285,
	"./law/white_king_law_back.svg": 7353,
	"./law/white_pawn_law_back.svg": 8730,
	"./law/white_queen_law_back.svg": 752,
	"./law/white_rook_law_back.svg": 6426,
	"./law_prestige/black_bishop_law_prestige_back.svg": 7689,
	"./law_prestige/black_king_law_prestige_back.svg": 4091,
	"./law_prestige/black_pawn_law_prestige_back.svg": 4631,
	"./law_prestige/black_queen_law_prestige_back.svg": 8367,
	"./law_prestige/black_rook_law_prestige_back.svg": 4977,
	"./law_prestige/white_bishop_law_prestige_back.svg": 3105,
	"./law_prestige/white_king_law_prestige_back.svg": 8959,
	"./law_prestige/white_pawn_law_prestige_back.svg": 6187,
	"./law_prestige/white_queen_law_prestige_back.svg": 7714,
	"./law_prestige/white_rook_law_prestige_back.svg": 2184,
	"./mafia/black_bishop_mafia_back.svg": 1497,
	"./mafia/black_king_mafia_back.svg": 5782,
	"./mafia/black_pawn_mafia_back.svg": 1629,
	"./mafia/black_queen_mafia_back.svg": 4993,
	"./mafia/black_rook_mafia_back.svg": 2770,
	"./mafia/white_bishop_mafia_back.svg": 1686,
	"./mafia/white_king_mafia_back.svg": 7624,
	"./mafia/white_pawn_mafia_back.svg": 8656,
	"./mafia/white_queen_mafia_back.svg": 975,
	"./mafia/white_rook_mafia_back.svg": 9580,
	"./mafia_rouge/black_bishop_mafia_rouge_back.svg": 3796,
	"./mafia_rouge/black_king_mafia_rouge_back.svg": 1928,
	"./mafia_rouge/black_pawn_mafia_rouge_back.svg": 5406,
	"./mafia_rouge/black_queen_mafia_rouge_back.svg": 6066,
	"./mafia_rouge/black_rook_mafia_rouge_back.svg": 3437,
	"./mafia_rouge/white_bishop_mafia_rouge_back.svg": 5203,
	"./mafia_rouge/white_king_mafia_rouge_back.svg": 5153,
	"./mafia_rouge/white_pawn_mafia_rouge_back.svg": 2302,
	"./mafia_rouge/white_queen_mafia_rouge_back.svg": 3659,
	"./mafia_rouge/white_rook_mafia_rouge_back.svg": 1539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5716;